import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import { gridMargin } from './general';
import QuickbooksFreightAccountContainer from '../../containers/billing/QuickbooksFreightAccount';

class FMPQuickbooksFreightAccountSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		const { quickbooksFreightAccounts, searchQuickbooksFreightAccounts } = this.props;
		if (_.isEmpty(quickbooksFreightAccounts)) {
			searchQuickbooksFreightAccounts();
		}
	}

	render() {
		const {
			label,
			value,
			path,
			onChange,
			error,
			helpText,
			md,
			readOnly,
			quickbooksFreightAccounts,
			quickbooksAccountMap,
		} = this.props;

		if (!quickbooksFreightAccounts) {
			return (
				<Grid item xs={12} md={md}>
					<Select value={'loading'} input={<Input id={path} readOnly={readOnly} />}>
						<MenuItem key={'loading mapped account freights'} value={'loading'} disabled>
							Loading mapped accounts for freight...
						</MenuItem>
					</Select>
				</Grid>
			);
		}

		const options = _.values(_.keyBy(quickbooksFreightAccounts, 'quickbooksAccountId')).map(
			(quickbooksFreightAccount) => {
				const { quickbooksAccountId } = quickbooksFreightAccount;
				const quickbooksAccount = quickbooksAccountMap[quickbooksAccountId] || { Name: 'Missing' };
				return { value: quickbooksAccountId, display: quickbooksAccount.Name };
			}
		);

		const hasError = !!error;
		const _onChange = (event) => {
			onChange(event.target.value, path);
		};

		return (
			<Grid item xs={12} md={md} style={gridMargin}>
				<FormControl fullWidth={true} error={hasError}>
					<InputLabel htmlFor={path}>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input id={path} readOnly={readOnly} />}
					>
						{_.sortBy(options, 'display').map((option) => {
							const { display, value } = option;
							return (
								<MenuItem key={value} value={value}>
									{display}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);
	}
}

FMPQuickbooksFreightAccountSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	searchQuickbooksFreightAccounts: PropTypes.func,
	quickbooksFreightAccounts: PropTypes.array,
	quickbooksAccountMap: PropTypes.object,

	md: PropTypes.number,
	helpText: PropTypes.string,
	readOnly: PropTypes.bool,
};

FMPQuickbooksFreightAccountSelect.defaultProps = {};

export default _.flow([QuickbooksFreightAccountContainer])(FMPQuickbooksFreightAccountSelect);
